import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { ReferenceTextCopy as ReferenceTextCopyType } from '../../types/page'
import { useSKU } from '../../hooks/useSKUs'
import ProductPriceInsert from '../ProductPackages/ProductPriceInsert'
import useDiscountToken from '../../hooks/useDiscountToken'
import LinkButton from '../../components/Link/LinkButton'
import { ReferenceTextCopyKeys } from '../../types/constants'
import { SplitPaymentLink } from '../../components/ProductPackages/SplitPaymentLink'
import { hasNonNullProperties } from '../../utils/utils'
import useBrand from '../../hooks/useBrand'

interface Props {
  reference: ReferenceTextCopyType
}

export const ReferenceTextCopy: React.FC<Props> = ({ reference }) => {
  const { classes } = useStyles()
  const discount = useDiscountToken()
  const sku = useSKU(
    reference.reference.items,
    reference.reference.planCode,
    discount,
    reference.reference.sort
  )
  const { isTopCVuk, isTopCV, isTopCvFr } = useBrand()
  return (
    <>
      {reference.key === ReferenceTextCopyKeys.Price ? (
        <>
          <ProductPriceInsert
            formattedAmount={sku?.formattedOriginalAmount}
            formattedDiscount={sku?.formattedDiscount}
            url={sku?.purchasePath}
            linkPriceClass={classes.linkPrice}
            originalPriceClass={classes.originalPrice}
          />
          {(isTopCV || isTopCVuk || isTopCvFr) &&
            sku &&
            hasNonNullProperties(sku.alternate_plan) && (
              <SplitPaymentLink
                intervalTimes={sku.alternate_plan.interval_times}
                planCode={sku.alternate_plan.plan_code}
                amount={sku.alternate_plan.amount}
              />
            )}
        </>
      ) : reference.key === ReferenceTextCopyKeys.OrderNow ? (
        <LinkButton href={sku?.purchasePath} mixpanelTracking={null}>
          {reference.name}
        </LinkButton>
      ) : (
        <span>{sku?.plan_short_name}</span>
      )}
    </>
  )
}

const useStyles = makeStyles()({
  originalPrice: {
    '&&': {
      fontSize: '1.375rem',
      lineHeight: '1',
      fontWeight: 700,
    },
  },
  linkPrice: {
    '&&': {
      fontSize: '1.875rem',
      lineHeight: '1',
      fontWeight: 700,
    },
  },
})

export default ReferenceTextCopy
